import { Injectable } from '@angular/core';

export interface AuthData {
  userID: string | null;
  persona: string;
  token: string | null;
  tokenType: string;
}

@Injectable({
  providedIn: 'root'
})
export class AuthUtilsService {

  /**
   * Gets authentication data from localStorage
   */
  getAuthData(): AuthData {
    return {
      userID: localStorage.getItem('userID'),
      persona: localStorage.getItem('persona') || '',
      token: localStorage.getItem('accessToken'),
      tokenType: localStorage.getItem('tokenType') || 'Bearer'
    };
  }

  /**
   * Creates HTTP headers with authentication token
   */
  createAuthHeaders(includeContentType: boolean = true): Record<string, string> {
    const authData = this.getAuthData();
    
    const headers: Record<string, string> = {};
    
    if (authData.token) {
      headers['Authorization'] = `${authData.tokenType} ${authData.token}`;
    }
    
    if (includeContentType) {
      headers['Content-Type'] = 'application/json';
    }
    
    return headers;
  }

  /**
   * Checks if user is authenticated
   */
  isAuthenticated(): boolean {
    return !!localStorage.getItem('accessToken');
  }

  /**
   * Gets the current user's persona in lowercase
   */
  getCurrentPersona(): string {
    return (localStorage.getItem('persona') || '').toLowerCase();
  }

  /**
   * Gets the current user ID as a number
   */
  getCurrentUserIdAsNumber(): number {
    return Number.parseInt(localStorage.getItem('userID') || '0', 10);
  }
}